import {
  ControlBlocksService,
  GetEspSystemData_GetEspSystemDataResponse,
  GetMeteoSourceBroadcastDevice_GetMeteoSourceBroadcastDeviceResponse,
  SetDeviceSourceModel,
  StateModel,
} from "../api";

export const TestApi = {
  getSystemData: (id: string): Promise<GetEspSystemData_GetEspSystemDataResponse> => {
    return ControlBlocksService.getApiControlBlocksSystemData(id);
  },

  getMeteoSource: (id: string): Promise<GetMeteoSourceBroadcastDevice_GetMeteoSourceBroadcastDeviceResponse> => {
    return ControlBlocksService.getApiControlBlocksMeteoSource(id);
  },

  updateGpsUseCoords: async (id: string, enabled: boolean): Promise<boolean> => {
    const payload: StateModel = {enabled};
    await ControlBlocksService.postApiControlBlocksGpsUseCoords(id, payload);
    return true;
  },

  updateGpsUseTime: async (id: string, enabled: boolean): Promise<boolean> => {
    const payload: StateModel = {enabled};
    await ControlBlocksService.postApiControlBlocksGpsUseTime(id, payload);
    return true;
  },

  updateGpsSource: async (id: string, deviceId: string | null): Promise<boolean> => {
    const payload: SetDeviceSourceModel = {deviceId};
    await ControlBlocksService.postApiControlBlocksGpsGpsSource(id, payload);
    return true;
  },

  updateMeteoSource: async (id: string, deviceId: string | null): Promise<boolean> => {
    const payload: SetDeviceSourceModel = {deviceId};
    await ControlBlocksService.postApiControlBlocksMeteoSource(id, payload);
    return true;
  },
};
